import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type ChipColorScheme = 'secondary' | 'warning' | 'neutral';

@Component({
  selector: 'markant-platform-chip',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipComponent {
  label = input.required<string>();
  colorScheme = input<ChipColorScheme>('secondary');
}
